import {
    Box,
    Container,
    Text,
  } from '@chakra-ui/react';

  export default function Footer() {
    return (
      <Box
       >
        <Container
          maxW={'6xl'}      
          justify={'center'}
          align={'center'}
          py={'2%'}
          pl={'4%'}>
          <Text>© 2023 Raul Villanueva Portfolio. All rights reserved</Text>
        </Container>
      </Box>
    );
  }